import { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import AuthLayout from '@/components/layouts/AuthLayout'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import MuiLink from '@mui/material/Link'

interface Props {
  reset_password_token: string
}

export default function ResetPassword({ reset_password_token }: Props) {
  const { data, setData, put, processing, errors } = useForm({
    user: {
      reset_password_token,
      password: '',
      password_confirmation: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    put('/users/password')
  }

  return (
    <AuthLayout title="Reset Password">
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        <TextField
          label="New Password"
          type="password"
          fullWidth
          margin="normal"
          value={data.user.password}
          onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
          error={!!errors['user.password']}
          helperText={errors['user.password']}
          autoFocus
        />
        <TextField
          label="Confirm New Password"
          type="password"
          fullWidth
          margin="normal"
          value={data.user.password_confirmation}
          onChange={(e) => setData('user', { ...data.user, password_confirmation: e.target.value })}
          error={!!errors['user.password_confirmation']}
          helperText={errors['user.password_confirmation']}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mt: 2, mb: 2 }}
        >
          Reset Password
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <MuiLink component={Link} href="/users/sign_in" underline="hover">
            Back to Sign In
          </MuiLink>
        </Box>
      </Box>
    </AuthLayout>
  )
}
